<template>
  <div>
    <router-link to="/dashboard/cdd-pool"
      ><button class="btn link">
        <i class="las la-angle-left"></i>Go Back
      </button></router-link
    >
    <div class="dashboard">
      <h3 class="dashboard-title">Pending Invitations</h3>
      <div class="dashboard-table">
        <div class="latest-update">
          <div class="table">
            <b-table small :fields="fields" :items="items" responsive="sm">
              <template #cell(name)="data">
                <div class="candidate-name">
                  {{ data.value.first }} {{ data.value.last }}
                </div>
              </template>
              <template #cell(email)="data">
                <div class="candidate-email">
                  {{ data.value.email }}
                </div>
              </template>
            </b-table>
            <Pagination />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from "../../components/ui/Pagination";
export default {
  name: "DashboardTable",
  components: {
    Pagination,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Candidate Name" },
        { key: "email", label: "Candidate Email" },
      ],
      items: [
        {
          name: { first: "John", last: "Doe" },
          email: {
            email: "jdoe@email.com",
          },
        },
        {
          name: { first: "John", last: "Doe" },
          email: {
            email: "jdoe@email.com",
          },
        },
        {
          name: { first: "John", last: "Doe" },
          email: {
            email: "jdoe@email.com",
          },
        },
        {
          name: { first: "John", last: "Doe" },
          email: {
            email: "jdoe@email.com",
          },
        },
        {
          name: { first: "John", last: "Doe" },
          email: {
            email: "jdoe@email.com",
          },
        },
        {
          name: { first: "John", last: "Doe" },
          email: {
            email: "jdoe@email.com",
          },
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/stylesheets/application";
.btn.link {
  background: transparent;
  color: $black;
  font-size: 14px;
  margin-bottom: 1rem;
  padding: 0;
  i {
    margin-right: 8px;
  }
  &:hover,
  &:focus {
    filter: opacity(70%);
  }
}
.dashboard-table {
  /deep/.table {
    color: #1a1a1a;
    .table-hover tbody tr:hover {
      background-color: #fafafa;
      color: $black;
    }
    table {
      thead {
        tr {
          font-size: 1em;
          font-weight: 700;
          padding: 1rem;

          th {
            border: 0;
            padding-bottom: 1rem;
            vertical-align: baseline;
            div {
              font-weight: 700;
            }
          }
        }
        .custom-label {
          font-size: 1em;
          font-weight: 700;
          line-height: 1.5rem;
        }
      }
      tbody {
        transition: all 0.4s ease-in-out;
        tr {
          line-height: normal;
          td {
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
              Helvetica, Arial, sans-serif, "Apple Color Emoji",
              "Segoe UI Emoji", "Segoe UI Symbol";
            font-size: 14px;
            padding: 1rem 5px;
          }
        }
      }
    }
  }
  .candidate-name,
  .candidate-email {
    span {
      line-height: normal;
    }
  }
  .candidate-name {
    font-weight: 700;
  }
}

@media only screen and (max-width: 991px) {
  .dashboard-table {
    /deep/.table {
      table {
        thead {
          tr {
            font-size: 10px;
            padding: 1rem;
          }
          th {
            line-height: 12px;
            padding-right: 5px;
          }
          .custom-label {
            font-size: 10px;
            line-height: 10px;
          }
        }
        tbody {
          tr {
            td {
              font-size: 10px;
              padding-right: 10px;
            }
          }
        }
      }
    }
    .candidate-name,
    .candidate-email {
      span {
        padding-right: 0;
      }
    }
  }
}
</style>
